module.exports = __webpack_public_path__ + "static/media/stockhausen_augen_23.b7531a67.jpg";